import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
const FAQS = [{
  q: '📦 ¿Qué es "El Apoyo Incondicional"?',
  a: 'Es una guía digital práctica diseñada específicamente para familiares de pacientes con cáncer. Te enseña un sistema emocional y organizativo para ser el mejor apoyo posible sin quebrarte en el proceso.'
}, {
  q: '📥 ¿Cómo recibo el contenido?',
  a: '¡Inmediatamente! Al completar tu compra de $7.77, recibirás un correo electrónico con el enlace de descarga directo. Es un producto 100% digital.'
}, {
  q: '⏱️ ¿Cuánto tiempo toma leerla?',
  a: 'Está diseñada para leerse en 15-20 minutos. Sabemos que no tienes tiempo que perder, por eso fuimos directo al grano con herramientas prácticas.'
}, {
  q: '🛡️ ¿Tienen garantía?',
  a: 'Sí. Si lees la guía y no sientes que tienes más claridad y herramientas para apoyar a tu familiar, te devolvemos el 100% de tu dinero sin preguntas.'
}];
export function FAQAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-[50px] px-[15px] bg-white" id="faq-section" data-id="element-102">
      <div className="container max-w-[600px] mx-auto px-[15px]" data-id="element-103">
        <h2 className="text-[24px] text-center mb-[30px] font-[800] text-[#1A1035] font-['Montserrat']" data-id="element-104">
          🤔 Preguntas Frecuentes
        </h2>

        <div className="space-y-3" data-id="element-105">
          {FAQS.map((faq, index) => <div key={index} className="rounded-[12px] overflow-hidden border border-gray-100 shadow-sm bg-[#F8F6FF] transition-all duration-300 hover:border-[#A78BFA]" data-id="element-106">
              <button className="w-full text-left p-[16px] font-[600] text-[15px] sm:text-[16px] text-[#1A1035] flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-107">
                <span className="pr-4" data-id="element-108">{faq.q}</span>
                {openIndex === index ? <ChevronUp className="text-[#7C3AED] flex-shrink-0" data-id="element-109" /> : <ChevronDown className="text-[#7C3AED] flex-shrink-0" data-id="element-110" />}
              </button>
              <div className={`px-[16px] overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-[200px] opacity-100 pb-[16px]' : 'max-h-0 opacity-0'}`} data-id="element-111">
                <p className="text-[#4B5563] text-[14px] leading-relaxed" data-id="element-112">
                  {faq.a}
                </p>
              </div>
            </div>)}
        </div>

        <a className="block w-full bg-gradient-to-br from-[#7C3AED] to-[#6D28D9] text-white border-none p-[16px] text-[18px] font-[700] rounded-[50px] cursor-pointer shadow-[0_8px_20px_rgba(124,58,237,0.3)] text-center no-underline uppercase font-['Montserrat'] animate-pulse-custom hover:transform hover:-translate-y-[3px] hover:scale-[1.02] hover:shadow-[0_12px_25px_rgba(124,58,237,0.5)] transition-all duration-400 mt-[30px]" href="#elige-tu-plan" data-id="element-113">
          Descargar La Guía Ahora
        </a>
      </div>
    </section>;
}